import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getPatientMedicalHistory, savePatientMedicalHistory, getPatientDetails } from '../../service/patienthistory';
import { getClinicalObservation, saveClinicalObservation } from "../../service/clinicalobservation";
import { getAssessment, saveAssessment } from "../../service/customerassessment";
import { getCustomer } from '../../service/customer';
import { updateTransactionStatus } from '../../service/appointment';

import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  FormControl,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Alert,
  Avatar,
  IconButton,
  Snackbar,
  Chip,
  CircularProgress
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import Navbar from '../navbar';

import { QUESTIONNAIRES, getQuestionnaire, getSeverity, getAssessmentsByCategory } from '../Assessments/questionnaires';


const FormField = React.memo(
  React.forwardRef(function FormField(
    { label, required, ...props },
    ref
  ) {
    return (
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            color: '#1a1a1a',
            mb: 1,
            fontSize: '0.875rem'
          }}
        >
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </Typography>

        <TextField
          {...props}
          inputRef={ref}
          fullWidth
          sx={{
            bgcolor: 'white',
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: '#4C41FF',
              },
            },
            ...props.sx
          }}
        />
      </Box>
    );
  })
);

const normalizePayload = (obj) => {
  const cleaned = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === 'string') {
      cleaned[key] = value.trim() === '' ? null : value;
    } else {
      cleaned[key] = value;
    }
  });
  return cleaned;
};


const CaseHistory = () => {
  const navigate = useNavigate();
  const { patientId, appointmentId } = useParams();

  const resolvedPatientId = String(patientId || '').trim();

  const [patientInfo, setPatientInfo] = useState({
    name: `Patient ${resolvedPatientId || ''}`,
    initials: resolvedPatientId ? resolvedPatientId.slice(-2) : 'PT',
  });

  const hasLoadedClinical = React.useRef(false);
  const autoSaveMedicalTimer = React.useRef(null);
  const autoSaveClinicalTimer = React.useRef(null);



  const hasAnyMedicalHistoryData = () => {
    return [
      formData.chief_complaint,
      formData.presenting_issue,
      formData.medical_history,
      formData.current_medications,
      formData.allergies,
      formData.family_history,
      formData.social_history,
      formData.mental_health_history,
      formData.substance_use,
      formData.previous_treatments,
      formData.current_stressors,
      formData.coping_mechanisms,
      formData.trauma_history,
      formData.patient_strengths,
    ].some(val => val && val.trim() !== '');
  };





  const [activeStep, setActiveStep] = useState(0);
  // Fetch patient details on component mount


  // useEffect(() => {
  //   if (!resolvedPatientId) return;

  //   const fetchPatientDetails = async () => {
  //     try {
  //       const data = await getPatientDetails(resolvedPatientId);
  //       if (data) {
  //         setPatientInfo(prev => ({
  //           ...prev,
  //           name: data.name || `Patient ${resolvedPatientId}`,
  //           initials: data.name
  //             ? data.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
  //             : resolvedPatientId.slice(-2)
  //         }));
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch patient details:', error);
  //       // Keep the default patient info if fetch fails
  //     }
  //   };

  //   fetchPatientDetails();
  // }, [resolvedPatientId]);

  const [triageTouched, setTriageTouched] = useState(false);


  const [step0Errors, setStep0Errors] = useState({
    chief_complaint: false,
    presenting_issue: false,
  });


  const [selectedAssessments, setSelectedAssessments] = useState(new Set());
  const [assessmentStatus, setAssessmentStatus] = useState({});
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [customerName, setCustomerName] = useState("")
  const [formData, setFormData] = useState({
    chief_complaint: '',
    presenting_issue: '',
    medical_history: '',
    current_medications: '',
    allergies: '',
    family_history: '',
    social_history: '',
    mental_health_history: '',
    substance_use: '',
    previous_treatments: '',
    current_stressors: '',
    coping_mechanisms: '',
    trauma_history: '',
    patient_strengths: '',
    sessionObservations: '',
    clinicalImpressions: '',
    therapistNotes: '',
    workingDiagnosis: '',
    recommendedIntervention: '',
    customIntervention: '',
    recommendedFrequency: '',
    treatmentGoals: '',
    treatmentObjectives: '',
    followUpPlan: '',
    additionalNotes: '',
    triageLevel: '',
    psychiatristName: '',
    hospitalName: '',
    referralNotes: '',
    sessionSummary: '',
    interventionsUsed: '',
    homeworkAssigned: '',
    planForNextSession: '',
    selectedAssessments: []
  });


  const [appointment, setAppointment] = useState(null);

  useEffect(() => {
    if (!appointmentId) return;

    const loadAppointment = async () => {
      try {
        const res = await fetch(`/api/v1/appointments/${appointmentId}`);
        if (!res.ok) throw new Error("Appointment fetch failed");

        const data = await res.json();
        setAppointment(data);          // ✅ STORE ONCE
        setCustomerName(data.customer_name);
        setIsNewCase(Boolean(data.is_new_case));
      } catch (err) {
        console.error(err);
      }
    };

    loadAppointment();
  }, [appointmentId]);


  useEffect(() => {
    if (!appointment) return;

    const statusToStepMap = {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 3, // Completed → last page (view mode)
    };

    setActiveStep(statusToStepMap[appointment.transaction_status] ?? 0);
  }, [appointment]);




  const [isNewCase, setIsNewCase] = useState(true);
  const [patientSummary, setPatientSummary] = useState({
    gender: '',
    dateOfBirth: '',
    age: '',
    totalSessions: 0,
    lastVisit: ''
  });

  //DOB TO AGe 
  // Function to calculate age from DOB string (format: DD/MM/YYYY)
const calculateAge = (dobString) => {
  if (!dobString || dobString === 'N/A') return 'N/A';
  
  try {
    // Parse DD/MM/YYYY format
    const parts = dobString.split('/');
    if (parts.length !== 3) return 'N/A';
    
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed
    const year = parseInt(parts[2], 10);
    
    const birthDate = new Date(year, month, day);
    const today = new Date();
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return `${age} years`;
  } catch (error) {
    console.error('Error calculating age:', error);
    return 'N/A';
  }
};


  useEffect(() => {
    if (!resolvedPatientId) return;

    const loadCustomerSummary = async () => {
      try {
        const data = await getCustomer(resolvedPatientId);

      setPatientSummary({
  gender: data?.gender || 'N/A',
  dateOfBirth: data?.dob
    ? new Date(data.dob).toLocaleDateString()
    : 'N/A',
  age: data?.dob ? calculateAge(new Date(data.dob).toLocaleDateString()) : 'N/A', // Add this line
  totalSessions: data?.total_sessions || 0,
  lastVisit: isNewCase 
    ? 'No visits yet' 
    : (data?.last_visit 
      ? new Date(data.last_visit).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      : 'No visits yet')
});
      } catch (err) {
        console.error("Failed to load customer summary", err);
      }
    };

    loadCustomerSummary();
  }, [resolvedPatientId, isNewCase]);


  const chiefComplaintRef = React.useRef(null);
  const presentingIssueRef = React.useRef(null);




  useEffect(() => {
    if (!resolvedPatientId || !appointmentId) return;

    let cancelled = false;

    const loadMedicalHistory = async () => {
      setLoadingHistory(true);
      setError('');
      console.log('[CaseHistory] GET medical history start', {
        patientId: resolvedPatientId,
        appointmentId: appointmentId
      });

      try {
        const data = await getPatientMedicalHistory(resolvedPatientId, appointmentId);

        if (cancelled) return;

        console.log('[CaseHistory] GET medical history success', data);

        if (data && typeof data === 'object') {
          setFormData(prev => ({
            ...prev,
            chief_complaint: data.chief_complaint || '',
            presenting_issue: data.presenting_issue || '',
            medical_history: data.medical_history || '',
            current_medications: data.current_medications || '',
            allergies: data.allergies || '',
            family_history: data.family_history || '',
            social_history: data.social_history || '',
            mental_health_history: data.mental_health_history || '',
            substance_use: data.substance_use || '',
            previous_treatments: data.previous_treatments || '',
            current_stressors: data.current_stressors || '',
            coping_mechanisms: data.coping_mechanisms || '',
            trauma_history: data.trauma_history || '',
            patient_strengths: data.patient_strengths || ''
          }));
        } else {
          console.warn('[CaseHistory] GET medical history returned empty/invalid payload', data);
        }
      } catch (err) {
        if (cancelled) return;
        console.error('[CaseHistory] GET medical history failed', err);
        setError(err?.message || 'Failed to load medical history');
      } finally {
        if (!cancelled) setLoadingHistory(false);
      }
    };

    loadMedicalHistory();

    return () => {
      cancelled = true;
    };
  }, [resolvedPatientId, appointmentId]); // Add appointmentId to the dependency array

  //clinical obseravtaion 
  useEffect(() => {
    if (!appointmentId) return;
    if (hasLoadedClinical.current) return;

    const loadClinicalObservation = async () => {
      try {
        const data = await getClinicalObservation(appointmentId);
        if (data) {
          // Predefined intervention values
          const predefinedInterventions = ['CBT', 'DBT', 'ACT', 'Psychodynamic', 'EMDR', 'Mindfulness', 'Solution-Focused', 'Other'];
          
          // Check if recommended_intervention is a predefined value or custom
          let recommendedIntervention = data.recommended_intervention || "";
          let customIntervention = "";
          
          if (recommendedIntervention && !predefinedInterventions.includes(recommendedIntervention)) {
            // It's a custom value, set dropdown to "Other" and store actual value in customIntervention
            customIntervention = recommendedIntervention;
            recommendedIntervention = "Other";
          }
          
          setFormData(prev => ({
            ...prev,
            sessionObservations: data.session_observations || "",
            clinicalImpressions: data.clinical_impressions || "",
            therapistNotes: data.therapist_notes || "",
            workingDiagnosis: data.working_diagnosis || "",
            recommendedIntervention: recommendedIntervention,
            customIntervention: customIntervention,
            recommendedFrequency: data.recommended_frequency || "",
            treatmentGoals: data.treatment_goals || "",
            treatmentObjectives: data.treatment_objectives || "",
            followUpPlan: data.follow_up_plan || "",
            additionalNotes: data.additional_notes || "",
            triageLevel: data.triage_level || "",
            sessionSummary: data.session_summary || "",
            interventionsUsed: data.interventions_used || "",
            homeworkAssigned: data.homework_assigned || "",
            planForNextSession: data.plan_for_next_session || "",
          }));

          // ✅ PRESELECT ASSESSMENTS
          if (!isNewCase && Array.isArray(data.assessment_keys)) {
            setSelectedAssessments(new Set(data.assessment_keys));
          }

          hasLoadedClinical.current = true;
        }
      } catch (err) {
        console.error("Failed to load clinical observations", err);
      }
    };

    loadClinicalObservation();
  }, [appointmentId]);

  // Autosave Patient Medical History (Step 0)
  useEffect(() => {
    if (!appointmentId) return;
    if (activeStep !== 0) return;

    // Check if any medical history field has data
    const hasMedicalData = [
      formData.chief_complaint,
      formData.presenting_issue,
      formData.medical_history,
      formData.current_medications,
      formData.allergies,
      formData.family_history,
      formData.social_history,
      formData.mental_health_history,
      formData.substance_use,
      formData.previous_treatments,
      formData.current_stressors,
      formData.coping_mechanisms,
      formData.trauma_history,
      formData.patient_strengths
    ].some(val => val && val.trim() !== '');

    if (!hasMedicalData) return;

    // Clear previous timer
    if (autoSaveMedicalTimer.current) {
      clearTimeout(autoSaveMedicalTimer.current);
    }

    // Set new timer for autosave
    autoSaveMedicalTimer.current = setTimeout(async () => {
      try {
        await savePatientMedicalHistory(
          resolvedPatientId,
          normalizePayload({
            appointment_id: Number(appointmentId),
            customer_id: Number(resolvedPatientId),
            chief_complaint: formData.chief_complaint,
            presenting_issue: formData.presenting_issue,
            medical_history: formData.medical_history,
            current_medications: formData.current_medications,
            allergies: formData.allergies,
            family_history: formData.family_history,
            social_history: formData.social_history,
            mental_health_history: formData.mental_health_history,
            substance_use: formData.substance_use,
            previous_treatments: formData.previous_treatments,
            current_stressors: formData.current_stressors,
            coping_mechanisms: formData.coping_mechanisms,
            trauma_history: formData.trauma_history,
            patient_strengths: formData.patient_strengths,
          })
        );
        console.log('[CaseHistory] Medical history autosaved');
      } catch (err) {
        console.error('[CaseHistory] Medical history autosave failed:', err);
      }
    }, 800);

    // Cleanup timer on unmount or dependency change
    return () => {
      if (autoSaveMedicalTimer.current) {
        clearTimeout(autoSaveMedicalTimer.current);
      }
    };
  }, [
    activeStep,
    appointmentId,
    resolvedPatientId,
    formData.chief_complaint,
    formData.presenting_issue,
    formData.medical_history,
    formData.current_medications,
    formData.allergies,
    formData.family_history,
    formData.social_history,
    formData.mental_health_history,
    formData.substance_use,
    formData.previous_treatments,
    formData.current_stressors,
    formData.coping_mechanisms,
    formData.trauma_history,
    formData.patient_strengths
  ]);

  // Autosave Clinical Observation (Steps 1-3)
  useEffect(() => {
    if (!appointmentId) return;
    if (activeStep <= 0) return;

    // Check if any clinical observation field has data
    const hasClinicalData = [
      formData.sessionObservations,
      formData.clinicalImpressions,
      formData.therapistNotes,
      formData.workingDiagnosis,
      formData.recommendedIntervention,
      formData.recommendedFrequency,
      formData.treatmentGoals,
      formData.treatmentObjectives,
      formData.followUpPlan,
      formData.additionalNotes,
      formData.triageLevel,
      formData.sessionSummary,
      formData.interventionsUsed,
      formData.homeworkAssigned,
      formData.planForNextSession
    ].some(val => val && val.trim() !== '');

    if (!hasClinicalData) return;

    // Clear previous timer
    if (autoSaveClinicalTimer.current) {
      clearTimeout(autoSaveClinicalTimer.current);
    }

    // Set new timer for autosave
    autoSaveClinicalTimer.current = setTimeout(async () => {
      try {
        const payload = normalizePayload({
          session_observations: formData.sessionObservations,
          clinical_impressions: formData.clinicalImpressions,
          therapist_notes: formData.therapistNotes,
          working_diagnosis: formData.workingDiagnosis,
          recommended_intervention: formData.recommendedIntervention,
          custom_intervention: formData.customIntervention,
          recommended_frequency: formData.recommendedFrequency,
          treatment_goals: formData.treatmentGoals,
          treatment_objectives: formData.treatmentObjectives,
          follow_up_plan: formData.followUpPlan,
          additional_notes: formData.additionalNotes,
          triage_level: formData.triageLevel,
          session_summary: formData.sessionSummary,
          interventions_used: formData.interventionsUsed,
          homework_assigned: formData.homeworkAssigned,
          plan_for_next_session: formData.planForNextSession,
        });

        // Include black triage fields if triage level is black
        if (formData.triageLevel === 'black') {
          payload.psychiatrist_name = formData.psychiatristName;
          payload.hospital_name = formData.hospitalName;
          payload.referral_notes = formData.referralNotes;
        }

        await saveClinicalObservation(appointmentId, payload);
        console.log('[CaseHistory] Clinical observation autosaved');
      } catch (err) {
        console.error('[CaseHistory] Clinical observation autosave failed:', err);
      }
    }, 800);

    // Cleanup timer on unmount or dependency change
    return () => {
      if (autoSaveClinicalTimer.current) {
        clearTimeout(autoSaveClinicalTimer.current);
      }
    };
  }, [
    activeStep,
    appointmentId,
    formData.sessionObservations,
    formData.clinicalImpressions,
    formData.therapistNotes,
    formData.workingDiagnosis,
    formData.recommendedIntervention,
    formData.recommendedFrequency,
    formData.treatmentGoals,
    formData.treatmentObjectives,
    formData.followUpPlan,
    formData.additionalNotes,
    formData.triageLevel,
    formData.psychiatristName,
    formData.hospitalName,
    formData.referralNotes,
    formData.sessionSummary,
    formData.interventionsUsed,
    formData.homeworkAssigned,
    formData.planForNextSession
  ]);

  const [showQuestionnaireModal, setShowQuestionnaireModal] = useState(false);
  const [currentQuestionnaire, setCurrentQuestionnaire] = useState(null);
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState({});
  const [questionnaireScores, setQuestionnaireScores] = useState({});

  const { anxiety, depression, other } = getAssessmentsByCategory();

  const steps = ['Patient History', 'Clinical Assessment', 'Treatment Plan', 'Session Notes'];

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleAssessmentToggle = (assessment) => {
    setFormData(prev => ({
      ...prev,
      selectedAssessments: prev.selectedAssessments.includes(assessment)
        ? prev.selectedAssessments.filter(a => a !== assessment)
        : [...prev.selectedAssessments, assessment]
    }));
  };

  const startAssessment = async (assessmentKey) => {
    const questionnaireData = getQuestionnaire(assessmentKey);
    setCurrentQuestionnaire({ type: assessmentKey, ...questionnaireData });
    setQuestionnaireAnswers({});
    setQuestionnaireScores({});

    // 👉 PRE-FILL if assessment already exists
    if (appointmentId) {
      try {
        const existing = await getAssessment(appointmentId, assessmentKey);

        if (existing?.answers) {
          const answers = {};
          const scores = {};

          // Handle the new format where answers is an object with question IDs as keys
          Object.entries(existing.answers).forEach(([questionId, optionIndex]) => {
            const questionIdNum = Number(questionId);
            answers[questionIdNum] = optionIndex;

            // Derive score from questionnaire config
            const question = getQuestionnaire(assessmentKey)
              ?.questions
              ?.find(q => q.id === questionIdNum);

            if (question && question.options && question.options[optionIndex]) {
              const optionScore = question.options[optionIndex]?.score || 0;
              scores[questionIdNum] = optionScore;
            }
          });

          setQuestionnaireAnswers(answers);
          setQuestionnaireScores(scores);
        }
      } catch (err) {
        // No assessment exists yet → ignore silently
        console.log("No previous assessment found");
      }
    }

    setShowQuestionnaireModal(true);
  };


  const selectAnswer = async (questionId, score, optionIndex) => {
    const updatedAnswers = {
      ...questionnaireAnswers,
      [questionId]: optionIndex,
    };

    const updatedScores = {
      ...questionnaireScores,
      [questionId]: score,
    };

    setQuestionnaireAnswers(updatedAnswers);
    setQuestionnaireScores(updatedScores);

    // AUTOSAVE ASSESSMENT DRAFT (PARTIAL)
    if (!appointmentId || !currentQuestionnaire?.type) return;

    try {
      await saveAssessment(appointmentId, {
        assessment_key: currentQuestionnaire.type.toLowerCase(),
        answers: updatedAnswers,
        total_score: currentQuestionnaire.maxScore,
        obtained_score: Object.values(updatedScores).reduce((s, v) => s + v, 0),
        is_draft: true // optional flag, backend may ignore
      });
    } catch (err) {
      console.error("Assessment draft autosave failed", err);
    }
  };

  const getCurrentScore = () => {
    return Object.values(questionnaireScores).reduce((sum, s) => sum + s, 0);
  };

  const submitQuestionnaire = async () => {
    try {
      if (!appointmentId || !currentQuestionnaire?.type) return;

      const totalScore = getCurrentScore();

      // Convert answers to a map where keys are question IDs and values are the selected options
      const answersMap = {};
      Object.entries(questionnaireAnswers).forEach(([qId, optionIndex]) => {
        answersMap[qId] = optionIndex;
      });

      await saveAssessment(appointmentId, {
        assessment_key: currentQuestionnaire.type.toLowerCase(),
        answers: answersMap,
        total_score: currentQuestionnaire.maxScore,
        obtained_score: totalScore
      });

      await computeAssessmentStatus();

      setShowQuestionnaireModal(false);
      setCurrentQuestionnaire(null);
      setQuestionnaireAnswers({});
      setQuestionnaireScores({});
    } catch (err) {
      console.error("Failed to save assessment", err);
    }
  };

  const computeAssessmentStatus = async () => {
    if (!appointmentId) return;

    const statusMap = {};

    for (const [key, q] of Object.entries(QUESTIONNAIRES)) {
      try {
        const res = await getAssessment(appointmentId, key);

        if (!res?.answers) {
          statusMap[key] = "none";
          continue;
        }

        const answeredCount = Object.keys(res.answers).length;
        const totalQuestions = q.questions.length;

        if (answeredCount === 0) {
          statusMap[key] = "none";
        } else if (answeredCount < totalQuestions) {
          statusMap[key] = "partial";
        } else {
          statusMap[key] = "completed";
        }

      } catch {
        statusMap[key] = "none";
      }
    }

    setAssessmentStatus(statusMap);
  };

  //  const handleNextStep = async () => {
  //   try {
  //     setError('');

  //     // STEP 0 → Save Patient History
  //     if (activeStep === 0) {
  //       if (!resolvedPatientId) {
  //         setError('Patient ID is missing');
  //         return;
  //       }

  //       setIsSaving(true);
  //       await savePatientMedicalHistory(resolvedPatientId, formData);
  //       setActiveStep(1);
  //       return;
  //     }

  //     // STEP 1 → Save Clinical Observations
  //     if (activeStep === 1) {
  //       if (!appointmentId) {
  //         setError('Appointment ID is missing');
  //         return;
  //       }

  //       setIsSaving(true);
  //       await saveClinicalObservation(appointmentId, {
  //         session_observations: formData.sessionObservations,
  //         clinical_impressions: formData.clinicalImpressions,
  //         therapist_notes: formData.therapistNotes,
  //       });

  //       setActiveStep(2);
  //       return;
  //     }

  //     // STEP 2+
  //     setActiveStep(prev => prev + 1);

  //   } catch (err) {
  //     console.error('[CaseHistory] Next step failed', err);
  //     setError('Failed to save data');
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

  const handleNextStep = async () => {
    try {
      setError('');
      //validate chief complaint and presenting issue
      if (activeStep === 0) {
        if (!resolvedPatientId || !appointmentId) {
          setError('Patient or Appointment ID is missing');
          return;
        }
        const errors = {
          chief_complaint: !formData.chief_complaint.trim(),
          presenting_issue: !formData.presenting_issue.trim(),
        };

        setStep0Errors(errors);


        let targetRef = null;

        if (errors.chief_complaint) {
          targetRef = chiefComplaintRef;
        } else if (errors.presenting_issue) {
          targetRef = presentingIssueRef;
        }




        setStep0Errors(errors);

        

        if (isNewCase && hasAnyMedicalHistoryData()) {
          setIsSaving(true);
          await savePatientMedicalHistory(
            resolvedPatientId,
            normalizePayload({
              appointment_id: Number(appointmentId),
              customer_id: Number(resolvedPatientId),

              chief_complaint: formData.chief_complaint,
              presenting_issue: formData.presenting_issue,
              medical_history: formData.medical_history,
              current_medications: formData.current_medications,
              allergies: formData.allergies,
              family_history: formData.family_history,
              social_history: formData.social_history,
              mental_health_history: formData.mental_health_history,
              substance_use: formData.substance_use,
              previous_treatments: formData.previous_treatments,
              current_stressors: formData.current_stressors,
              coping_mechanisms: formData.coping_mechanisms,
              trauma_history: formData.trauma_history,
              patient_strengths: formData.patient_strengths,
            })
          );

          await updateTransactionStatus(appointmentId, 1);
        }

        setActiveStep(1);
        return;
      }






      // STEP 1 → Save Clinical Observations
      if (activeStep === 1) {
        if (!appointmentId) {
          setError('Appointment ID is missing');
          return;
        }

        setIsSaving(true);
        await saveClinicalObservation(
          appointmentId,
          normalizePayload({
            session_observations: formData.sessionObservations,
            clinical_impressions: formData.clinicalImpressions,
            therapist_notes: formData.therapistNotes,
          })
        );


        setActiveStep(2);
        return;
      }

      // STEP 2 → Save Treatment Plan ✅ (THIS WAS MISSING)
      if (activeStep === 2) {
        if (!appointmentId) {
          setError('Appointment ID is missing');
          return;
        }

        setIsSaving(true);
        await saveClinicalObservation(
          appointmentId,
          normalizePayload({
            working_diagnosis: formData.workingDiagnosis,
            recommended_intervention: formData.recommendedIntervention,
            custom_intervention: formData.customIntervention,
            recommended_frequency: formData.recommendedFrequency,
            treatment_goals: formData.treatmentGoals,
            treatment_objectives: formData.treatmentObjectives,
            follow_up_plan: formData.followUpPlan,
            additional_notes: formData.additionalNotes,
            triage_level: formData.triageLevel,

            psychiatrist_name:
              formData.triageLevel === 'black'
                ? formData.psychiatristName
                : null,

            hospital_name:
              formData.triageLevel === 'black'
                ? formData.hospitalName
                : null,

            referral_notes:
              formData.triageLevel === 'black'
                ? formData.referralNotes
                : null,
          })
        );


        setActiveStep(3);
        return;
      }

      // STEP 3+
      setActiveStep(prev => prev + 1);

    } catch (err) {
      console.error('[CaseHistory] Next step failed', err);
      setError('Failed to save data');
    } finally {
      setIsSaving(false);
    }
  };


  // save data of the black triage in db 
  const handleSaveReferral = async () => {

    if (!formData.psychiatristName || !formData.hospitalName) {
      setError('Psychiatrist name and hospital are required for black triage');
      return;
    }

    try {
      setIsSaving(true);


      await saveClinicalObservation(appointmentId, {
        triage_level: 'black',
        psychiatrist_name: formData.psychiatristName,
        hospital_name: formData.hospitalName,
        referral_notes: formData.referralNotes || null,
      });


      setTriageTouched(false);
      alert('Referral details saved successfully');

    } catch (err) {
      console.error('Failed to save referral', err);
      setError('Failed to save referral details');
    } finally {
      setIsSaving(false);
    }
  };


  const handleSubmit = async () => {

    const isSessionNotesEmpty =
      !formData.sessionSummary?.trim() &&
      !formData.planForNextSession?.trim();

    if (isSessionNotesEmpty) {
      const confirmed = window.confirm(
        "You haven't added session notes. Do you want to complete the session anyway?"
      );

      if (!confirmed) return;
    }
    try {
      if (!appointmentId) {
        setError('Appointment ID is missing');
        return;
      }

      setIsSaving(true);
      await saveClinicalObservation(
        appointmentId,
        normalizePayload({
          session_summary: formData.sessionSummary,
          interventions_used: formData.interventionsUsed,
          homework_assigned: formData.homeworkAssigned,
          plan_for_next_session: formData.planForNextSession,
        })
      );


      navigate('/dashboard');
    } catch (err) {
      console.error('[CaseHistory] Final submission failed:', err);
      setError(err?.response?.data?.error || 'Failed to submit case history');
    } finally {
      setIsSaving(false);
    }
  };
  const handleCancel = () => {
    navigate('/dashboard');
  };

  // Compute assessment status when entering Clinical Assessment step
  useEffect(() => {
    if (activeStep === 1 && appointmentId) {
      computeAssessmentStatus();
    }
  }, [activeStep, appointmentId]);

  const SectionTitle = ({ icon, title, subtitle }) => (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ fontSize: '1.25rem', fontWeight: 600, color: '#1a1a1a', display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <span>{icon}</span> {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: '0.875rem', color: '#6b7280' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );

  // Get initials from customer name
  const patientInitials = customerName
    ? customerName
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
    : 'PT';

  // Cleanup timers on component unmount
  useEffect(() => {
    return () => {
      if (autoSaveMedicalTimer.current) {
        clearTimeout(autoSaveMedicalTimer.current);
      }
      if (autoSaveClinicalTimer.current) {
        clearTimeout(autoSaveClinicalTimer.current);
      }
    };
  }, []);

  return (
    <Box sx={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)'
    }}>
      <Navbar />

      {/* Header */}
      <Box sx={{
        bgcolor: 'white', borderBottom: '1px solid #e5e7eb', background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)'
      }}>
        <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 2, sm: 3 } }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/dashboard')}
            sx={{ mb: 2, color: '#4C41FF', textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: '#f0f0ff' } }}
          >
            Back to Appointments
          </Button>

          {/* Patient Info Banner */}
          <Card sx={{ bgcolor: '#fff7ed', border: '2px solid #fed7aa', boxShadow: 'none', p: { xs: 1, sm: 1.5 } }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 1, sm: 1.5 } }}>
              <Box sx={{
                width: { xs: 48, sm: 64 },
                height: { xs: 48, sm: 64 },
                borderRadius: 2,
                bgcolor: '#fb923c',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: { xs: '1.25rem', sm: '1.5rem' },
                boxShadow: '0 4px 6px rgba(251, 146, 60, 0.3)'
              }}>
                {/* {resolvedPatientId?.slice(-2) || 'PT'} */}
                {patientInitials}


              </Box>
              <Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 0.75, sm: 1.5 }, mb: 0.75 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: { xs: '1.25rem', sm: '1.5rem' }, color: '#1a1a1a' }}>
                    {customerName}
                  </Typography>
                  <Box
                    sx={{
                      px: 2,
                      py: 0.5,
                      bgcolor: isNewCase ? '#22c55e' : '#fb923c',
                      color: 'white',
                      borderRadius: 1.5,
                      fontSize: '0.75rem',
                      fontWeight: 700
                    }}
                  >
                    {isNewCase ? 'NEW' : 'RETURNING'}
                  </Box>

                </Box>
                <Typography sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' }, color: '#92400e', fontWeight: 500, wordBreak: 'break-word' }}>
                  ID: {resolvedPatientId || 'N/A'}
                </Typography>
              </Box>
              <Box sx={{ textAlign: { xs: 'left', sm: 'right' }, width: { xs: '100%', sm: 'auto' } }}>
                <Typography sx={{ fontSize: '0.7rem', color: '#92400e', fontWeight: 600, mb: 0.25 }}>
                  Booking Date
                </Typography>
                <Typography sx={{ fontSize: '0.8rem', color: '#6b7280' }}>
                  {appointment?.created_at ? new Date(appointment.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'N/A'}
                </Typography>
              </Box>
            </Box>

            {/* Patient Summary */}
            <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
              <Box sx={{
                bgcolor: 'white',
                p: 1.5,
                borderRadius: 2,
                border: '1px solid #e5e7eb',
                minWidth: 100,
                flex: 1,
                textAlign: 'center'
              }}>
                <Typography sx={{ fontSize: '0.7rem', color: '#6b7280', fontWeight: 600, mb: 0.5 }}>
                  GENDER
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#1a1a1a', fontWeight: 500 }}>
                  {patientSummary.gender || 'N/A'}
                </Typography>
              </Box>

              <Box sx={{
                bgcolor: 'white',
                p: 1.5,
                borderRadius: 2,
                border: '1px solid #e5e7eb',
                minWidth: 100,
                flex: 1,
                textAlign: 'center'
              }}>
               <Typography sx={{ fontSize: '0.7rem', color: '#6b7280', fontWeight: 600, mb: 0.5 }}>
  Age
</Typography>
<Typography sx={{ fontSize: '0.875rem', color: '#1a1a1a', fontWeight: 500 }}>
  {patientSummary.age || 'N/A'}
</Typography>
              </Box>

              <Box sx={{
                bgcolor: 'white',
                p: 1.5,
                borderRadius: 2,
                border: '1px solid #e5e7eb',
                minWidth: 100,
                flex: 1,
                textAlign: 'center'
              }}>
                <Typography sx={{ fontSize: '0.7rem', color: '#6b7280', fontWeight: 600, mb: 0.5 }}>
                  TOTAL SESSIONS
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#1a1a1a', fontWeight: 500 }}>
                  {patientSummary.totalSessions || 0}
                </Typography>
              </Box>

              <Box sx={{
                bgcolor: 'white',
                p: 1.5,
                borderRadius: 2,
                border: '1px solid #e5e7eb',
                minWidth: 100,
                flex: 1,
                textAlign: 'center'
              }}>
                <Typography sx={{ fontSize: '0.7rem', color: '#6b7280', fontWeight: 600, mb: 0.5 }}>
                  LAST VISIT
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#1a1a1a', fontWeight: 500 }}>
                  {patientSummary.lastVisit || 'No visits yet'}
                </Typography>
              </Box>
            </Box>
          </Card>

          {/* Progress Stepper */}
          <Box sx={{ mt: 4 }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      '& .MuiStepLabel-label': {
                        fontWeight: activeStep === index ? 600 : 400,
                        color: activeStep === index ? '#4C41FF' : '#6b7280'
                      }
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 2, sm: 3, md: 4 } }}>
        {/* Step 1: Patient History */}
        {activeStep === 0 && (
          <Box>

            {/* 🔹 CASE HISTORY HEADER (NEW vs RETURNING) */}
            <SectionTitle
              icon="📋"
              title={
                isNewCase
                  ? "Initial Patient Case History"
                  : "Patient Health Records"
              }
              subtitle={
                isNewCase
                  ? "Complete this form during the first consultation. This information will be saved permanently to the patient's record."
                  : undefined
              }
            />

            {/* Chief Complaint - Highlighted */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2, bgcolor: '#eff6ff', border: '2px solid #3b82f6' }}>
              <SectionTitle
                icon="🎯"
                title="Chief Complaint"
                subtitle="Primary reason for seeking treatment"
              />
              <TextField
                inputRef={chiefComplaintRef}
                fullWidth
                multiline
                rows={3}
                required
                error={step0Errors.chief_complaint}
                helperText={step0Errors.chief_complaint ? 'Chief Complaint is required' : ''}
                value={formData.chief_complaint}
                onChange={(e) => {
                  handleChange('chief_complaint', e.target.value);
                  setStep0Errors(prev => ({ ...prev, chief_complaint: false }));
                }}
              />


            </Card>

            {/* Presenting Issue */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <SectionTitle
                icon="📝"
                title="Presenting Issue"
                subtitle="Detailed description of symptoms"
              />
              <FormField
                ref={presentingIssueRef}
                label="Symptoms & Impact"
                required
                multiline
                rows={5}
                error={step0Errors.presenting_issue}
                helperText={step0Errors.presenting_issue ? 'Presenting Issue is required' : ''}
                value={formData.presenting_issue}
                onChange={(e) => {
                  handleChange('presenting_issue', e.target.value);
                  setStep0Errors(prev => ({ ...prev, presenting_issue: false }));
                }}
              />


            </Card>

            {/* Medical & Medication History */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <SectionTitle
                icon="🏥"
                title="Medical Information"
              />
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Medical History"
                    multiline
                    rows={4}
                    placeholder="Past and current medical conditions..."
                    value={formData.medical_history}
                    onChange={(e) => handleChange('medical_history', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Current Medications"
                    multiline
                    rows={4}
                    placeholder="List all current medications and dosages..."
                    value={formData.current_medications}
                    onChange={(e) => handleChange('current_medications', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Allergies"
                    multiline
                    rows={3}
                    placeholder="Any known allergies (medications, food, etc.)"
                    value={formData.allergies}
                    onChange={(e) => handleChange('allergies', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Family History"
                    multiline
                    rows={3}
                    placeholder="Family mental health or medical history"
                    value={formData.family_history}
                    onChange={(e) => handleChange('family_history', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* Social & Mental Health History */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <SectionTitle
                icon="👥"
                title="Social & Mental Health Background"
              />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField
                    label="Social History"
                    multiline
                    rows={3}
                    placeholder="Marital status, occupation, living situation, relationships, lifestyle..."
                    value={formData.social_history}
                    onChange={(e) => handleChange('social_history', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Mental Health History"
                    multiline
                    rows={4}
                    placeholder="Previous mental health diagnoses or treatment..."
                    value={formData.mental_health_history}
                    onChange={(e) => handleChange('mental_health_history', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Substance Use"
                    multiline
                    rows={4}
                    placeholder="Alcohol, tobacco, drugs - type and frequency..."
                    value={formData.substance_use}
                    onChange={(e) => handleChange('substance_use', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* Risk Factors */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <SectionTitle
                icon="⚠️"
                title="Risk Factors & Stressors"
              />
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Previous Treatments"
                    multiline
                    rows={4}
                    placeholder="Past therapy, hospitalizations, medications tried..."
                    value={formData.previous_treatments}
                    onChange={(e) => handleChange('previous_treatments', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Current Stressors"
                    multiline
                    rows={4}
                    placeholder="Work, relationships, financial, health concerns..."
                    value={formData.current_stressors}
                    onChange={(e) => handleChange('current_stressors', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Coping Mechanisms"
                    multiline
                    rows={4}
                    placeholder="How does patient currently manage stress?"
                    value={formData.coping_mechanisms}
                    onChange={(e) => handleChange('coping_mechanisms', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField
                    label="Trauma History"
                    multiline
                    rows={4}
                    placeholder="Any history of trauma, abuse, or significant adverse experiences..."
                    value={formData.trauma_history}
                    onChange={(e) => handleChange('trauma_history', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* Patient Strengths - Highlighted */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2, bgcolor: '#f0fdf4', border: '2px solid #22c55e' }}>
              <SectionTitle
                icon="💪"
                title="Patient Strengths & Resources"
              />
              <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Support system, personal strengths, resilience factors, resources..."
                value={formData.patient_strengths}
                onChange={(e) => handleChange('patient_strengths', e.target.value)}
                sx={{
                  bgcolor: 'white',
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#22c55e' },
                    '&.Mui-focused fieldset': { borderColor: '#22c55e', borderWidth: 2 }
                  }
                }}
              />
            </Card>
          </Box>
        )}

        {/* Step 2: Clinical Assessment */}
        {activeStep === 1 && (
          <Box>
            {/* Clinical Observations */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2, bgcolor: '#faf5ff', border: '1px solid #e9d5ff' }}>
              <SectionTitle
                icon="👁️"
                title="Clinical Observations"
                subtitle="Initial impressions and observations"
              />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField
                    label="Session Observations"
                    multiline
                    rows={4}
                    placeholder="Patient's presentation, behavior, mood, affect, appearance..."
                    value={formData.sessionObservations}
                    onChange={(e) => handleChange('sessionObservations', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    label="Clinical Impressions"
                    multiline
                    rows={4}
                    placeholder="Initial clinical impressions and formulation..."
                    value={formData.clinicalImpressions}
                    onChange={(e) => handleChange('clinicalImpressions', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    label="Therapist Notes"
                    multiline
                    rows={4}
                    placeholder="Additional notes, insights, or concerns..."
                    value={formData.therapistNotes}
                    onChange={(e) => handleChange('therapistNotes', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* Assign Assessments */}
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <SectionTitle
                icon="📊"
                title="Assign Assessments"
                subtitle="Click any assessment to administer (optional)"
              />

              {/* Anxiety */}
              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 1, borderBottom: '2px solid #fed7aa' }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#ed6c02' }} />
                  <Typography sx={{ fontWeight: 600, color: '#ed6c02', fontSize: '0.9375rem' }}>
                    Anxiety Assessments
                  </Typography>
                  <Chip label={`${anxiety.length} types`} size="small" sx={{ bgcolor: '#fff4e5', color: '#ed6c02' }} />
                </Box>
                <Grid container spacing={2}>
                  {anxiety.map(([key, q]) => (
                    <Grid item xs={12} sm={6} md={4} key={key}>
                      <Card
                        onClick={() => startAssessment(key)}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          cursor: 'pointer',
                          border: selectedAssessments.has(key)
                            ? '2px solid #22c55e'
                            : '2px solid #ffe0b2',

                          bgcolor: selectedAssessments.has(key)
                            ? '#f0fdf4'
                            : 'transparent',

                          boxShadow: selectedAssessments.has(key) ? 3 : 0,
                          borderRadius: 2,
                          '&:hover': { borderColor: '#ed6c02', boxShadow: 2, bgcolor: '#fff7ed' }
                        }}
                      >
                        <Typography fontSize="1.5rem">{q.icon}</Typography>
                        <Typography fontWeight="bold" fontSize="0.85rem">{q.shortName}</Typography>
                        <Typography variant="caption" color="text.secondary">{q.questions.length} items</Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Depression */}
              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 1, borderBottom: '2px solid #bbdefb' }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#1976d2' }} />
                  <Typography sx={{ fontWeight: 600, color: '#1976d2', fontSize: '0.9375rem' }}>
                    Depression Assessments
                  </Typography>
                  <Chip label={`${depression.length} types`} size="small" sx={{ bgcolor: '#e3f2fd', color: '#1976d2' }} />
                </Box>
                <Grid container spacing={2}>
                  {depression.map(([key, q]) => (
                    <Grid item xs={12} sm={6} md={4} key={key}>
                      <Card
                        onClick={() => startAssessment(key)}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          cursor: 'pointer',
                          border: selectedAssessments.has(key)
                            ? '2px solid #22c55e'
                            : '2px solid #ffe0b2',

                          bgcolor: selectedAssessments.has(key)
                            ? '#f0fdf4'
                            : 'transparent',

                          boxShadow: selectedAssessments.has(key) ? 3 : 0,
                          borderRadius: 2,
                          '&:hover': { borderColor: '#1976d2', boxShadow: 2, bgcolor: '#eff6ff' }
                        }}
                      >
                        <Typography fontSize="1.5rem">{q.icon}</Typography>
                        <Typography fontWeight="bold" fontSize="0.85rem">{q.shortName}</Typography>
                        <Typography variant="caption" color="text.secondary">{q.questions.length} items</Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Other */}
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 1, borderBottom: '2px solid #e1bee7' }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#9c27b0' }} />
                  <Typography sx={{ fontWeight: 600, color: '#9c27b0', fontSize: '0.9375rem' }}>
                    Other Assessments
                  </Typography>
                  <Chip label={`${other.length} types`} size="small" sx={{ bgcolor: '#f3e5f5', color: '#9c27b0' }} />
                </Box>
                <Grid container spacing={2}>
                  {other.map(([key, q]) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                      <Card
                        onClick={() => startAssessment(key)}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          cursor: 'pointer',
                          border: selectedAssessments.has(key)
                            ? '2px solid #22c55e'
                            : '2px solid #ffe0b2',

                          bgcolor: selectedAssessments.has(key)
                            ? '#f0fdf4'
                            : 'transparent',

                          boxShadow: selectedAssessments.has(key) ? 3 : 0,
                          borderRadius: 2,
                          '&:hover': { borderColor: '#9c27b0', boxShadow: 2, bgcolor: '#faf5ff' }
                        }}
                      >
                        <Typography fontSize="1.5rem">{q.icon}</Typography>
                        <Typography fontWeight="bold" fontSize="0.85rem">{q.shortName}</Typography>
                        <Typography variant="caption" color="text.secondary">{q.questions.length} items</Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Card>
          </Box>
        )}

        {/* Step 3: Treatment Plan */}
        {activeStep === 2 && (
          <Box>
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2, bgcolor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
              <SectionTitle
                icon="📋"
                title="Initial Treatment Plan"
              />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField
                    label="Working Diagnosis"
                    required
                    placeholder="e.g., Generalized Anxiety Disorder (F41.1)"
                    value={formData.workingDiagnosis}
                    onChange={(e) => handleChange('workingDiagnosis', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ fontWeight: 600, color: '#1a1a1a', mb: 1, fontSize: '0.875rem' }}>
                    Recommended Intervention <span style={{ color: '#ef4444' }}>*</span>
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={formData.recommendedIntervention}
                      onChange={(e) => handleChange('recommendedIntervention', e.target.value)}
                      displayEmpty
                      sx={{ bgcolor: 'white' }}
                    >
                      <MenuItem value="">Select intervention type...</MenuItem>
                      <MenuItem value="CBT">Cognitive Behavioral Therapy (CBT)</MenuItem>
                      <MenuItem value="DBT">Dialectical Behavior Therapy (DBT)</MenuItem>
                      <MenuItem value="ACT">Acceptance and Commitment Therapy (ACT)</MenuItem>
                      <MenuItem value="Psychodynamic">Psychodynamic Therapy</MenuItem>
                      <MenuItem value="EMDR">EMDR</MenuItem>
                      <MenuItem value="Mindfulness">Mindfulness-Based Therapy</MenuItem>
                      <MenuItem value="Solution-Focused">Solution-Focused Brief Therapy</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {formData.recommendedIntervention === 'Other' && (
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ fontWeight: 600, color: '#1a1a1a', mb: 1, fontSize: '0.875rem' }}>
                      Specify Intervention <span style={{ color: '#ef4444' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter custom intervention type..."
                      value={formData.customIntervention}
                      onChange={(e) => handleChange('customIntervention', e.target.value)}
                      sx={{ bgcolor: 'white' }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={6}>
                  <Typography sx={{ fontWeight: 600, color: '#1a1a1a', mb: 1, fontSize: '0.875rem' }}>
                    Recommended Frequency <span style={{ color: '#ef4444' }}>*</span>
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={formData.recommendedFrequency}
                      onChange={(e) => handleChange('recommendedFrequency', e.target.value)}
                      displayEmpty
                      sx={{ bgcolor: 'white' }}
                    >
                      <MenuItem value="">Select frequency...</MenuItem>
                      <MenuItem value="Weekly">Weekly</MenuItem>
                      <MenuItem value="Bi-weekly">Bi-weekly (Every 2 weeks)</MenuItem>
                      <MenuItem value="Monthly">Monthly</MenuItem>
                      <MenuItem value="As needed">As needed</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormField
                    label="Therapeutic Goals"
                    required
                    multiline
                    rows={5}
                    placeholder="List specific, measurable treatment goals..."
                    value={formData.treatmentGoals}
                    onChange={(e) => handleChange('treatmentGoals', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    label="Treatment Objectives"
                    // required
                    multiline
                    rows={2}
                    placeholder="List specific, measurable treatment objectives..."
                    value={formData.treatmentObjectives}
                    onChange={(e) => handleChange('treatmentObjectives', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    label="Follow-up Plan"
                    // required
                    multiline
                    rows={2}
                    placeholder="List specific, measurable follow-up plan..."
                    value={formData.followUpPlan}
                    onChange={(e) => handleChange('followUpPlan', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    label="Additional Notes"
                    // required
                    multiline
                    rows={2}
                    placeholder="Add any additional notes..."
                    value={formData.additionalNotes}
                    onChange={(e) => handleChange('additionalNotes', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: 600, color: '#1a1a1a', mb: 2, fontSize: '0.875rem' }}>
                    Triage Level <span style={{ color: '#ef4444' }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    value={formData.triageLevel}
                    onChange={(e) => {
                      setTriageTouched(true);

                      handleChange('triageLevel', e.target.value);
                    }}

                  >
                    <Grid container spacing={2}>
                      {[
                        { value: 'green', color: '#22c55e', label: 'Green', desc: 'Low risk' },
                        { value: 'amber', color: '#f59e0b', label: 'Amber', desc: 'Moderate risk' },
                        { value: 'red', color: '#ef4444', label: 'Red', desc: 'High risk' },
                        { value: 'black', color: '#1a1a1a', label: 'Black', desc: 'Critical' }
                      ].map(({ value, color, label, desc }) => (
                        <Grid item xs={6} sm={3} key={value}>
                          <Box sx={{
                            bgcolor: 'white',
                            p: 2.5,
                            borderRadius: 2,
                            border: formData.triageLevel === value ? `3px solid ${color}` : '1px solid #e5e7eb',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            '&:hover': { borderColor: color, transform: 'translateY(-2px)', boxShadow: `0 4px 12px ${color}33` }
                          }}>
                            <FormControlLabel
                              value={value}
                              control={<Radio sx={{ '&.Mui-checked': { color } }} />}
                              label={
                                <Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                    <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: color }} />
                                    <Typography sx={{ fontWeight: 700, fontSize: '0.9375rem' }}>{label}</Typography>
                                  </Box>
                                  <Typography sx={{ fontSize: '0.75rem', color: '#6b7280' }}>{desc}</Typography>
                                </Box>
                              }
                              sx={{ m: 0 }}
                            />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </RadioGroup>
                </Grid>
              </Grid>
            </Card>
          </Box>
        )}

        {/* Step 4: Session Notes */}
        {activeStep === 3 && (
          <Box>
            <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2, bgcolor: '#eff6ff', border: '1px solid #bfdbfe' }}>
              <SectionTitle
                icon="💬"
                title="First Consultation Notes"
              />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField
                    label="Session Summary"
                    multiline
                    rows={5}
                    placeholder="Summary of what was discussed during the first consultation..."
                    value={formData.sessionSummary}
                    onChange={(e) => handleChange('sessionSummary', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField
                    label="Interventions Used"
                    multiline
                    rows={4}
                    placeholder="e.g., Psychoeducation, rapport building, breathing exercises..."
                    value={formData.interventionsUsed}
                    onChange={(e) => handleChange('interventionsUsed', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField
                    label="Homework Assigned"
                    multiline
                    rows={4}
                    placeholder="Tasks assigned to patient..."
                    value={formData.homeworkAssigned}
                    onChange={(e) => handleChange('homeworkAssigned', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormField
                    label="Plan for Next Session"
                    multiline
                    rows={3}
                    placeholder="What to focus on in the next session..."
                    value={formData.planForNextSession}
                    onChange={(e) => handleChange('planForNextSession', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* End of Session Options */}
            {/* <Card sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 3, borderRadius: 2 }}>
              <Typography sx={{ fontWeight: 600, color: '#1a1a1a', mb: 3, fontSize: '1rem' }}>
                End of Session Options
              </Typography>
              <RadioGroup
                value={formData.endSessionOption}
                onChange={(e) => handleChange('endSessionOption', e.target.value)}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ 
                      bgcolor: formData.endSessionOption === 'book' ? '#eff6ff' : '#f9fafb', 
                      p: 3, 
                      borderRadius: 2, 
                      border: formData.endSessionOption === 'book' ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      '&:hover': { borderColor: '#3b82f6' }
                    }}>
                      <FormControlLabel
                        value="book"
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography sx={{ fontWeight: 600, color: '#1a1a1a', fontSize: '0.9375rem', mb: 0.5 }}>
                              📅 Book Next Consultation
                            </Typography>
                            <Typography sx={{ fontSize: '0.8125rem', color: '#6b7280' }}>
                              Schedule follow-up appointment via Echobuddy
                            </Typography>
                          </Box>
                        }
                        sx={{ m: 0 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ 
                      bgcolor: formData.endSessionOption === 'end' ? '#f9fafb' : 'white', 
                      p: 3, 
                      borderRadius: 2, 
                      border: formData.endSessionOption === 'end' ? '2px solid #6b7280' : '1px solid #e5e7eb',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      '&:hover': { borderColor: '#6b7280' }
                    }}>
                      <FormControlLabel
                        value="end"
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography sx={{ fontWeight: 600, color: '#1a1a1a', fontSize: '0.9375rem', mb: 0.5 }}>
                              ✓ End Session Only
                            </Typography>
                            <Typography sx={{ fontSize: '0.8125rem', color: '#6b7280' }}>
                              Save case history without booking next appointment
                            </Typography>
                          </Box>
                        }
                        sx={{ m: 0 }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </RadioGroup>
            </Card> */}
          </Box>
        )}

        {/* Navigation Buttons */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', gap: 2, mt: 4, pt: 3, borderTop: '2px solid #e5e7eb' }}>
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              px: { xs: 3, sm: 4 },
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              color: '#6b7280',
              borderColor: '#d1d5db',
              width: { xs: '100%', sm: 'auto' },
              order: { xs: 2, sm: 0 },
              '&:hover': { borderColor: '#9ca3af', bgcolor: '#f9fafb' }
            }}
          >
            Cancel
          </Button>

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, width: { xs: '100%', sm: 'auto' } }}>
            {activeStep > 0 && (
              <Button
                variant="outlined"
                onClick={() => setActiveStep(prev => prev - 1)}
                sx={{
                  px: { xs: 3, sm: 4 },
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  color: '#4C41FF',
                  borderColor: '#4C41FF',
                  width: { xs: '100%', sm: 'auto' },
                  '&:hover': { borderColor: '#3730a3', bgcolor: '#f0f0ff' }
                }}
              >
                Previous
              </Button>
            )}

            {activeStep < steps.length - 1 ? (

              <Button
                variant="contained"
                onClick={handleNextStep}
                disabled={isSaving || loadingHistory}
                sx={{
                  minWidth: 120,
                  bgcolor: '#4f46e5',
                  '&:hover': { bgcolor: '#4338ca' },
                  '&.Mui-disabled': { bgcolor: '#e5e7eb' }
                }}
              >
                {isSaving ? 'Saving...' : 'Next Step'}
              </Button>

            ) : (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isSaving}
                startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
                sx={{
                  px: { xs: 3, sm: 4 },
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  bgcolor: '#22c55e',
                  width: { xs: '100%', sm: 'auto' },
                  '&:hover': { bgcolor: '#16a34a' }
                }}
              >
                Complete Initial Session
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {/* QUESTIONNAIRE MODAL */}
      <Dialog open={showQuestionnaireModal} onClose={() => setShowQuestionnaireModal(false)} maxWidth="lg" fullWidth>
        {currentQuestionnaire && (() => {
          const qData = getQuestionnaire(currentQuestionnaire.type);
          const answered = Object.keys(questionnaireAnswers).length;
          const total = qData?.questions?.length || 0;
          const progress = total > 0 ? Math.round((answered / total) * 100) : 0;
          const currentScore = getCurrentScore();
          const currentSeverity = getSeverity(currentQuestionnaire.type, currentScore);

          return (
            <>
              <DialogTitle
                sx={{
                  bgcolor: 'primary.main',
                  color: '#ffffff',
                  py: 1,
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                  {/* LEFT: ICON + TITLE */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography sx={{ fontSize: '1.5rem', color: '#ffffff' }}>
                      {qData?.icon}
                    </Typography>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: '1rem',
                          fontWeight: 700,
                          lineHeight: 1.2,
                          color: '#ffffff',
                        }}
                      >
                        {qData?.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '0.75rem',
                          color: '#ffffff',
                          opacity: 0.95,
                        }}
                      >
                        {qData?.shortName} · {total} Questions
                      </Typography>
                    </Box>
                  </Box>

                  {/* RIGHT: SCORE BOX */}
                  <Box
                    sx={{
                      bgcolor: 'rgba(255,255,255,0.15)',
                      borderRadius: 2,
                      px: 1.5,
                      py: 1,
                      minWidth: 120,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '0.65rem',
                        color: '#ffffff',
                        opacity: 0.9,
                      }}
                    >
                      SCORE
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '1.25rem',
                        fontWeight: 700,
                        lineHeight: 1,
                        color: '#ffffff',
                      }}
                    >
                      {currentScore}
                      <Typography
                        component="span"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#ffffff',
                          opacity: 0.9,
                        }}
                      >
                        /{qData?.maxScore}
                      </Typography>
                    </Typography>

                    <LinearProgress
                      variant="determinate"
                      value={(currentScore / (qData?.maxScore || 1)) * 100}
                      sx={{
                        mt: 0.5,
                        height: 6,
                        borderRadius: 3,
                        bgcolor: 'rgba(255,255,255,0.35)',
                        '& .MuiLinearProgress-bar': {
                          bgcolor:
                            currentSeverity?.color === 'success'
                              ? '#4caf50'
                              : currentSeverity?.color === 'warning'
                                ? '#ff9800'
                                : '#f44336',
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        color: '#ffffff',
                      }}
                    >
                      {currentSeverity?.level}
                    </Typography>
                  </Box>

                  {/* CLOSE BUTTON */}
                  <IconButton
                    onClick={() => setShowQuestionnaireModal(false)}
                    sx={{ color: '#ffffff', ml: 1 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                {/* PROGRESS */}
                <Box sx={{ mt: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#ffffff' }}>
                      Progress: {answered}/{total}
                    </Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#ffffff' }}>
                      {progress}%
                    </Typography>
                  </Box>

                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      height: 6,
                      borderRadius: 3,
                      bgcolor: 'rgba(255,255,255,0.35)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: '#ffffff',
                      },
                    }}
                  />
                </Box>
              </DialogTitle>

              <Alert severity="info" sx={{ mx: 3, mt: 2 }}><strong>Instructions:</strong> {qData?.instructions}</Alert>
              <DialogContent sx={{ maxHeight: '50vh' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 2 }}>
                  {qData?.questions?.map((question, idx) => {
                    const isAnswered = questionnaireAnswers[question.id] !== undefined;
                    const selectedScore = questionnaireScores[question.id];
                    return (
                      <Card key={question.id} sx={{ p: 2, border: isAnswered ? '2px solid #4caf50' : '2px solid #e0e0e0', bgcolor: isAnswered ? '#f1f8e9' : 'white' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                          <Avatar sx={{ bgcolor: isAnswered ? 'success.main' : 'grey.400', width: 32, height: 32, fontSize: '0.875rem' }}>{idx + 1}</Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography fontWeight="500">{question.text}</Typography>
                          </Box>
                          {isAnswered && <Chip label={`+${selectedScore}`} size="small" sx={{ bgcolor: 'success.main', color: 'white', fontWeight: 'bold' }} />}
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: question.options.length <= 4 ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)' }, gap: 1, ml: 5 }}>
                          {question.options.map((opt, optIdx) => (
                            <Button key={optIdx} variant={questionnaireAnswers[question.id] === optIdx ? 'contained' : 'outlined'}
                              onClick={() => selectAnswer(question.id, opt.score, optIdx)}
                              sx={{ textTransform: 'none', justifyContent: 'flex-start', p: 1.5, textAlign: 'left', ...(questionnaireAnswers[question.id] === optIdx && { bgcolor: 'primary.main', color: 'white' }) }}>
                              <Box>
                                <Typography variant="body2">{opt.text}</Typography>
                                <Typography variant="caption" sx={{ opacity: 0.7 }}>Score: {opt.score}</Typography>
                              </Box>
                            </Button>
                          ))}
                        </Box>
                      </Card>
                    );
                  })}
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 2, py: 1.5, bgcolor: '#f5f5f5', justifyContent: 'space-between' }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                  <Box sx={{ bgcolor: 'white', px: 1.5, py: 1, borderRadius: 1.5, boxShadow: 1 }}>

                    <Typography sx={{ fontSize: '0.65rem', color: '#6b7280', lineHeight: 1 }}>Total Score</Typography>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: 'primary.main', lineHeight: 1.2 }}>
                      {currentScore} / {qData?.maxScore}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Severity Level</Typography>
                    <Chip label={currentSeverity?.level} sx={{ display: 'block', mt: 0.5, fontWeight: 'bold', bgcolor: currentSeverity?.color === 'success' ? '#e8f5e9' : currentSeverity?.color === 'warning' ? '#fff3e0' : '#ffebee', color: currentSeverity?.color === 'success' ? '#2e7d32' : currentSeverity?.color === 'warning' ? '#ed6c02' : '#c62828' }} />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button onClick={() => setShowQuestionnaireModal(false)}>Cancel</Button>
                  <Button variant="contained" color="success" onClick={submitQuestionnaire} disabled={answered < total}>
                    ✓ Submit Assessment ({answered}/{total})
                  </Button>
                </Box>
              </DialogActions>
            </>
          );
        })()}
      </Dialog>



      {/* red snackbar */}
      <Snackbar
        open={triageTouched && formData.triageLevel === 'red'}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          '& .MuiSnackbarContent-root': {
            padding: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
          }
        }}
      >

        <Box
          sx={{
            width: { xs: '95vw', md: '80vw' },
            bgcolor: '#fee2e2',
            border: '2px solid #ef4444',
            borderRadius: 2,
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          {/* LEFT TEXT */}
          <Box>
            <Typography sx={{ fontWeight: 700, color: '#b91c1c', fontSize: '1rem' }}>
              ⚠️ High Risk – Immediate Action Required
            </Typography>
            <Typography sx={{ color: '#dc2626', fontSize: '0.875rem', mt: 0.5 }}>
              Contact 24×7 Crisis Helpline for immediate support
            </Typography>
          </Box>

          {/* RIGHT BUTTONS */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setTriageTouched(false);
                handleChange('triageLevel', '');
              }}

              sx={{
                borderColor: '#dc2626',
                color: '#dc2626',
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': {
                  borderColor: '#b91c1c',
                  backgroundColor: '#fee2e2'
                }
              }}
            >
              Acknowledge & Clear
            </Button>
            <Button
              variant="contained"
              startIcon={<span>📞</span>}
              sx={{
                bgcolor: '#dc2626',
                px: 3,
                py: 1.2,
                borderRadius: 2,
                fontWeight: 700,
                textTransform: 'none',
                '&:hover': { bgcolor: '#b91c1c' }
              }}
              onClick={() => window.open('tel:+919152987821')}
            >
              24×7 Helpline&nbsp; +91 8080808080
            </Button>
          </Box>
        </Box>
      </Snackbar>


      {/* black snackbar  */}
      <Snackbar
        open={triageTouched && formData.triageLevel === 'black'}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          '& .MuiSnackbarContent-root': {
            padding: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
          }
        }}
      >
        <Box
          sx={{
            width: { xs: '95vw', md: '70vw' },
            bgcolor: '#f3f4f6',
            border: '2px solid #111827',
            borderRadius: 3,
            p: 3,
          }}
        >
          {/* HEADER */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
            <Typography fontSize="1.5rem">🏥</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#111827' }}>
              Critical Case – Refer to Psychiatrist
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setTriageTouched(false);
                handleChange('triageLevel', '');
              }}

              sx={{
                color: '#111827',
                '&:hover': { bgcolor: '#e5e7eb' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* DESCRIPTION */}
          <Typography sx={{ color: '#4b5563', fontSize: '0.875rem', mb: 3 }}>
            This case requires immediate psychiatric evaluation. Please provide referral details below:
          </Typography>

          {/* FORM */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 0.5 }}>
                Psychiatrist Name
              </Typography>
              <TextField
                fullWidth
                placeholder="Name"
                size="small"
                value={formData.psychiatristName}
                onChange={(e) =>
                  handleChange('psychiatristName', e.target.value)
                }
                sx={{ bgcolor: 'white', borderRadius: 2 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 0.5 }}>
                Hospital/Clinic
              </Typography>
              <TextField
                fullWidth
                placeholder="Hospital name"
                size="small"
                value={formData.hospitalName}
                onChange={(e) =>
                  handleChange('hospitalName', e.target.value)
                }
                sx={{ bgcolor: 'white', borderRadius: 2 }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 0.5 }}>
                Referral Notes
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Reason for referral and relevant details..."
                value={formData.referralNotes}
                onChange={(e) =>
                  handleChange('referralNotes', e.target.value)
                }
                sx={{ bgcolor: 'white', borderRadius: 2 }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox />}
                label={
                  <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
                    Close this case after referral
                  </Typography>
                }
              />
            </Grid>
          </Grid>
          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              bgcolor: '#111827',
              fontWeight: 700,
              textTransform: 'none',
              '&:hover': { bgcolor: '#000' }
            }}
            onClick={handleSaveReferral}
          >
            💾 Save Referral Details
          </Button>

        </Box>
      </Snackbar>

  
     




    </Box>
  );
};

export default CaseHistory; 